class Menu {
  constructor() {
    this.menu = null;  // Propiedad de la clase para almacenar el menú
    this.initMenu();
  }

  initMenu() {
    this.menu = this.querySelectorSafe(".noahs-menu");
    this.menuInner = this.menu ? this.querySelectorSafe(".menu__inner i", this.menu) : null;
    this.menuArrow = this.menu ? this.querySelectorSafe(".menu__arrow", this.menu) : null;
    this.menuTitle = this.menu ? this.querySelectorSafe(".menu__title", this.menu) : null;
    this.burger = this.querySelectorSafe(".burger");
    this.overlay = this.querySelectorSafe(".overlay");

    if (this.burger) {
      this.burger.addEventListener("click", () => this.toggleMenu());
    }

    if (this.overlay) {
      this.overlay.addEventListener("click", () => this.toggleMenu());
    }

    if (this.menuArrow) {
      this.menuArrow.addEventListener("click", () => this.hideSubMenu());
    }

    if (this.menuTitle) {
      this.menuTitle.addEventListener("click", () => this.hideSubMenu());
    }

    if (this.menuInner) {
      this.menuInner.addEventListener("click", (e) => this.toggleSubMenu(e));
    }

    window.addEventListener("resize", () => {
      if (window.innerWidth >= 768 && this.menu && this.menu.classList.contains("is-active")) {
        this.toggleMenu();
      }
    });
  }

  querySelectorSafe(selector, parent = document) {
    const element = parent.querySelector(selector);
    return element ? element : null;
  }

  toggleMenu() {
    if (this.menu) {
      this.menu.classList.toggle("is-active");
    }
    if (this.overlay) {
      this.overlay.classList.toggle("is-active");
    }
  }

  toggleSubMenu(e) {
    e.preventDefault();
    if (this.menu && this.menu.classList.contains("is-active") && e.target.closest(".menu__dropdown")) {
      const children = e.target.closest(".menu__dropdown");
      this.showSubMenu(children);
    }
  }

  showSubMenu(children) {
    if (children) {
      const subMenu = children.querySelector(".submenu");
      if (subMenu) {
        subMenu.classList.add("is-active");
        subMenu.style.animation = "slideLeft 0.35s ease forwards";

        const menuTitleText = children.querySelector("i").parentNode.childNodes[0].textContent;
        if (this.menu && this.menu.querySelector(".menu__title")) {
          this.menu.querySelector(".menu__title").textContent = menuTitleText;
        }
        if (this.menu && this.menu.querySelector(".menu__header")) {
          this.menu.querySelector(".menu__header").classList.add("is-active");
        }
      }
    }
  }

  hideSubMenu() {
    if (this.menu && this.menu.querySelector(".menu__title")) {
      this.menu.querySelector(".menu__title").textContent = "";
    }
    if (this.menu && this.menu.querySelector(".menu__header")) {
      this.menu.querySelector(".menu__header").classList.remove("is-active");
    }
    if (this.menu && this.menu.querySelector(".submenu")) {
      const subMenu = this.menu.querySelector(".submenu");
      if (subMenu) {
        subMenu.style.animation = "slideRight 0.35s ease forwards";
        setTimeout(() => {
          subMenu.classList.remove("is-active");
        }, 300);
      }
    }
  }
}

export default Menu;
